export class SearchCondition {
  subject_code: string = null
  subject_name: string = ""
  curriculum_code: string = null
  page: number = 1
  row_count: number =  100
}

export class Subject {
  id: number
  subject_code: number
  subject_name: string
  curriculum_code: number
  curriculum_name: string
  report_count: number
  full_count: number
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.subject_code = x.subject_code;
    this.subject_name = x.subject_name;
    this.curriculum_code = x.curriculum_code;
    this.curriculum_name = x.curriculum_name;
    this.full_count = x.full_count;
    this.report_count = x.report_count;
  }
}